import { useTranslation } from "react-i18next";
import {
  ENTERPRISE_INTAKE_MODULE1_FIELD_BRANDS_OR_VISUAL_IDENTITIES_COUNT,
  ENTERPRISE_INTAKE_MODULE1_FIELD_CREATIVE_VOLUME_VARIATION,
  ENTERPRISE_INTAKE_MODULE1_FIELD_FORMATS_PER_PIECE_AVG,
  ENTERPRISE_INTAKE_MODULE1_FIELD_INDEPENDENT_BRAND_CONFIGS_COUNT,
  ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_ADDITIONAL_EDITS_COUNT,
  ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_IMAGE_ANIMATIONS_COUNT,
  ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_NEW_IMAGES_COUNT,
  ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_VIDEOS_COUNT,
  ENTERPRISE_INTAKE_MODULE1_FIELD_PEAK_MONTH_PIECES_COUNT,
  ENTERPRISE_INTAKE_MODULE1_FIELD_VERSIONS_PER_PIECE_BEFORE_APPROVAL,
  ENTERPRISE_INTAKE_MODULE1_HINT_FORMATS_PER_PIECE,
  ENTERPRISE_INTAKE_MODULE1_HINT_INDEPENDENT_BRAND_CONFIGS,
  ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_ADDITIONAL_EDITS,
  ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_IMAGE_ANIMATIONS,
  ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_VIDEOS,
  ENTERPRISE_INTAKE_MODULE1_HINT_VERSIONS_PER_PIECE,
  ENTERPRISE_INTAKE_MODULE1_INTRO,
} from "../../../../i18n/keysTranslations";
import ReadOnlySectionGrid from "../../../PreActivation/components/ReadOnlySectionGrid";
import ModuleSectionIntro from "../shared/ModuleSectionIntro";
import NumericFieldBlock from "../shared/NumericFieldBlock";
import VolumeVariationField from "../shared/VolumeVariationField";

const Module1CreativeAssetsSection = ({ control, errors, readOnly }) => {
  const { t } = useTranslation();

  return (
    <ReadOnlySectionGrid readOnly={readOnly}>
      {!readOnly ? (
        <ModuleSectionIntro introKey={ENTERPRISE_INTAKE_MODULE1_INTRO} />
      ) : null}

      <NumericFieldBlock
        name="module1BrandsOrVisualIdentitiesCount"
        labelKey={
          ENTERPRISE_INTAKE_MODULE1_FIELD_BRANDS_OR_VISUAL_IDENTITIES_COUNT
        }
        required
        control={control}
        errors={errors}
        readOnly={readOnly}
        t={t}
      />

      <NumericFieldBlock
        name="module1IndependentBrandConfigsCount"
        labelKey={
          ENTERPRISE_INTAKE_MODULE1_FIELD_INDEPENDENT_BRAND_CONFIGS_COUNT
        }
        hintKey={ENTERPRISE_INTAKE_MODULE1_HINT_INDEPENDENT_BRAND_CONFIGS}
        required
        control={control}
        errors={errors}
        readOnly={readOnly}
        t={t}
      />

      <NumericFieldBlock
        name="module1MonthlyNewImagesCount"
        labelKey={ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_NEW_IMAGES_COUNT}
        required
        control={control}
        errors={errors}
        readOnly={readOnly}
        t={t}
      />

      <NumericFieldBlock
        name="module1FormatsPerPieceAvg"
        labelKey={ENTERPRISE_INTAKE_MODULE1_FIELD_FORMATS_PER_PIECE_AVG}
        hintKey={ENTERPRISE_INTAKE_MODULE1_HINT_FORMATS_PER_PIECE}
        required
        control={control}
        errors={errors}
        readOnly={readOnly}
        t={t}
      />

      <NumericFieldBlock
        name="module1MonthlyAdditionalEditsCount"
        labelKey={
          ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_ADDITIONAL_EDITS_COUNT
        }
        hintKey={ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_ADDITIONAL_EDITS}
        control={control}
        errors={errors}
        readOnly={readOnly}
        t={t}
      />

      <NumericFieldBlock
        name="module1MonthlyVideosCount"
        labelKey={ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_VIDEOS_COUNT}
        hintKey={ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_VIDEOS}
        required
        control={control}
        errors={errors}
        readOnly={readOnly}
        t={t}
      />

      <NumericFieldBlock
        name="module1MonthlyImageAnimationsCount"
        labelKey={
          ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_IMAGE_ANIMATIONS_COUNT
        }
        hintKey={ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_IMAGE_ANIMATIONS}
        required
        control={control}
        errors={errors}
        readOnly={readOnly}
        t={t}
      />

      <NumericFieldBlock
        name="module1VersionsPerPieceBeforeApproval"
        labelKey={
          ENTERPRISE_INTAKE_MODULE1_FIELD_VERSIONS_PER_PIECE_BEFORE_APPROVAL
        }
        hintKey={ENTERPRISE_INTAKE_MODULE1_HINT_VERSIONS_PER_PIECE}
        required
        control={control}
        errors={errors}
        readOnly={readOnly}
        t={t}
      />

      <VolumeVariationField
        variationName="module1CreativeVolumeVariation"
        peakName="module1PeakMonthPiecesCount"
        labelKey={ENTERPRISE_INTAKE_MODULE1_FIELD_CREATIVE_VOLUME_VARIATION}
        peakLabelKey={ENTERPRISE_INTAKE_MODULE1_FIELD_PEAK_MONTH_PIECES_COUNT}
        control={control}
        errors={errors}
        readOnly={readOnly}
      />
    </ReadOnlySectionGrid>
  );
};

export default Module1CreativeAssetsSection;
